module.exports = __webpack_public_path__ + "static/media/10.026f3a5e.mp3";